import { Component, ViewChild } from '@angular/core';
import 'moment/locale/id';
import * as moment from 'moment';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BaseListBComponent } from '../../../libraries/base/list/base-list.bcomponent';
import { SuratJalanBateraiRestService } from '../surat-jalan-baterai-rest.service';
import { ExportDataTableService } from '../../../libraries/export/export-data-table.service';
import { AuthenticationService } from '../../../libraries/auth/authentication.service';
import Swal from 'sweetalert2';
import { AclService } from '../../../libraries/auth/acl.service';
import { DetailModalComponent } from '../detail/detail-modal.component';

@Component({
  selector: 'app-surat-jalan-baterai-list',
  templateUrl: 'surat-jalan-baterai-list.component.html',
  styleUrls: ['../surat-jalan-baterai-module.scss']
})
export class SuratJalanBateraiListComponent extends BaseListBComponent<any> {
  @ViewChild('detailModal') detailModal: DetailModalComponent;
  canAccess(pageAction: string) {
    const userAccess: string[] = this._AclService?.exclusivePermissions;
    return userAccess.find(action => action === pageAction);
  }
  value = JSON.parse(localStorage.getItem('ngx-webstorage|currentuser') || '{}');

  tableColumns = [
    {
      i18nLabel: 'ui.suratJalanBaterai.entity.no',
      field: 'no'
    },
    {
      i18nLabel: 'ui.suratJalanBaterai.entity.expand',
      field: '',
      name: 'expand',
    },
    {
      i18nLabel: 'ui.suratJalanBaterai.entity.noTicket',
      field: 'noTicket',
      name: 'noTicket',
      sort: true
    },
    {
      i18nLabel: 'ui.suratJalanBaterai.entity.detail',
      field: '',
      name: 'detail',
      sort: false
    },
    {
      i18nLabel: 'ui.suratJalanBaterai.entity.createdBy',
      field: '',
      name: 'createdBy',
      sort: true
    },
    {
      i18nLabel: 'ui.suratJalanBaterai.entity.createdAt',
      field: 'openTicketDate',
      name: 'createdAt',
      sort: true
    },
    {
      i18nLabel: 'ui.suratJalanBaterai.entity.closedAt',
      field: 'closeTicketDate',
      sort: true
    },
    {
      i18nLabel: 'ui.suratJalanBaterai.entity.sjbStatus',
      field: '',
      name: 'sjbStatus',
      sort: true
    },
    {
      i18nLabel: 'ui.suratJalanBaterai.entity.status',
      field: '',
      name: 'status',
      sort: true
    }
  ];

  tableColumnsShow: boolean = false;
  tableColumnsToggle = this._gridTableToggle.mapToggleOptionsFromColumns(this.tableColumns);
  isLoadingExportExcel: boolean = false;
  noTicket: string = "";
  noSjb: string = "";

  ticketStatuses = [
    {
      text: 'Semua Status',
      value: ''
    },
    {
      text: 'Open',
      value: 'open'
    },
    {
      text: 'Closed',
      value: 'closed'
    },
  ];

  dealerFilter = [
    {
      name: 'Semua Dealer',
      _id: ''
    }
  ];

  constructor(
    public _authentication: AuthenticationService,
    private _SuratJalanBateraiRest: SuratJalanBateraiRestService,
    private _export: ExportDataTableService,
    private _AclService: AclService
  ) {
    super();
    this.componentId = 'SuratJalanBateraiListComponent';
    this.headerTitle = 'ui.suratJalanBaterai.list.title';

    this.qParams.status = '';
    this.qParams.dealerId = '';
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'loadData',
      handle: event => {
        const qOption = event.data.qOption;
        qOption['limit'] = qOption['take'];
        delete qOption['take'];
        delete qOption['skip'];
        const qParams = Object.assign({}, event.data.qParams, qOption, this.qParams);
        // return this._SuratJalanBateraiRest.findAll(qParams).pipe(
        return this._SuratJalanBateraiRest.findAll(qParams).pipe(
          switchMap(doc => {
            const dataFormatted = doc?.data?.map(d => {
              // d.createdAt = moment(d?.createdAt).format('DD MMMM YYYY HH:mm');
              // d.updatedAt = moment(d?.updatedAt).format('DD MMMM YYYY HH:mm');
              d.openTicketDate = moment(d?.openTicketDate).format('DD MMMM YYYY HH:mm');
              d.closeTicketDate = d.closeTicketDate ? moment(d?.closeTicketDate).format('DD MMMM YYYY HH:mm') : "-";
              d.suratJalanBaterai = d?.suratJalanBaterai?.map(sjb => {
                sjb.createdAt = sjb?.createdAt ? moment(sjb?.createdAt).format('DD MMMM YYYY HH:mm') : "-";
                return sjb;
              });
              return d;
            });
            this.noTicket = doc.noTicket;
            this.noSjb = doc.noSjb;
            doc.data = dataFormatted;
            return of(doc);
          })
          // switchMap(doc => {
          //   const dataFormatted = doc?.data?.map(d => {
          //     // d.createdAt = moment(d?.createdAt).format('DD MMMM YYYY HH:mm');
          //     // d.updatedAt = moment(d?.updatedAt).format('DD MMMM YYYY HH:mm');
          //     d.openTicketDate = moment(d?.openTicketDate).format('DD MMMM YYYY HH:mm');
          //     d.closeTicketDate = d.closeTicketDate ? moment(d?.closeTicketDate).format('DD MMMM YYYY HH:mm') : "-";
          //     return d;
          //   });
          //   doc.data = dataFormatted;
          //   console.log("dataFormatted", dataFormatted);
          //   return of(doc);
          // })
        );
      },
      wrapRetryableTask: true,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () => this.page.compHookService?.callMultipleHooks(['SuratJalanBateraiListComponent:workflowLoadData'])
    });
  }

  appOnInit() {
    super.appOnInit();

    this.getDealers();

    return this.callHook('init');
  }

  async onDownloadExcel() {
    this.isLoadingExportExcel = true;
    try {
      const result = await this._SuratJalanBateraiRest.findAll({}).toPromise();
      const mapOption = {
        fullname: { header: 'Nama' },
        phone: { header: 'Telepon' },
        nik: { header: 'NIK (KTP)' },
        dob: { header: 'Tanggal Lahir' },
        gender: { header: 'Jenis Kelamin' },
        email: { header: 'Email' },
        address: { header: 'Alamat' },
        createdAt: { header: 'Tanggal Dibuat' }
      };
      const payload = result.data.map(item => ({
        ...item,
        dob: moment(item?.dob).format('DD MMMM YYYY'),
        gender: item?.gender == 'M' ? 'Laki-laki' : 'Perempuan',
        createdAt: moment(item?.createdAt).format('DD MMMM YYYY HH:mm')
      }));
      this._export.export({
        extension: 'xlsx',
        fileName: 'SuratJalanBaterai',
        records: payload,
        mapOptions: mapOption,
        templateData: null,
        pdfOptions: null
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoadingExportExcel = false;
    }
  }

  onCloseTicket(suratJalanBateraiId: string) {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Apakah anda ingin meng-close request faktur ini?',
      icon: 'question',
      showCancelButton: true
    }).then(result => {
      if (result.value) {
        this.closeTicket(suratJalanBateraiId);
      } else {
        return;
      }
    });
  }

  async closeTicket(id) {
    await this._SuratJalanBateraiRest
      .close(id)
      .toPromise()
      .then(response => {
        if (response) {
          Swal.fire('Surat jalan baterai closed successfully!', '', 'success');
          this.callHookDirectly('init');
        }
      })
      .catch(error => {
        this.comp._globalSystemMessage.log({
          message: 'Error',
          type: 'error',
          scroll: true
        });
      });
  }

  getDealers() {
    this._SuratJalanBateraiRest.getDealers().subscribe((response: any) => {
      const data = response?.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
      this.dealerFilter = [...this.dealerFilter, ...data];
    });
  }

  getStatusColor(status: string) {
    switch (status) {
      case 'open':
      case 'submitted':
        return 'primary';
      case 'on delivery':
      case 'delivered':
        return 'success'
      case 'cancelled':
        return 'danger'
      case 'approved':
        return 'tertiary';
      case 'closed':
        return 'secondary';
      case 'draft':
        return 'warning';
      default:
        return 'primary';
    }
  }

  removeDash(str: string): string {
    if (str.toLowerCase() === 'cancelled') return 'Rejected';
    
    return str
      .replace(/[_-]/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }  

  openDetailModal() {
    this.detailModal.openModal();
  }
}
